import { render, staticRenderFns } from "./CostItemContainerSpecialties.vue?vue&type=template&id=695c694e&scoped=true&"
import script from "./CostItemContainerSpecialties.vue?vue&type=script&lang=js&"
export * from "./CostItemContainerSpecialties.vue?vue&type=script&lang=js&"
import style0 from "./CostItemContainerSpecialties.vue?vue&type=style&index=0&id=695c694e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695c694e",
  null
  
)

export default component.exports